<template>
  <v-application v-if="access.employee_time_cards">
    <v-layout row class="ma-2">
      <v-flex class="px-2 mt-2" md3 xs6>
        <v-datetime-picker
          v-model="options.start_date"
          solo
          label="Start date"
          :max="options.end_date"
        />
      </v-flex>
      <v-flex class="px-2 mt-2" md3 xs6>
        <v-datetime-picker
          v-model="options.end_date"
          solo
          label="End date"
          :min="options.start_date"
        />
      </v-flex>

      <v-flex class="px-2 mt-2" md2 xs4>
        <v-combobox
          v-model="store"
          :items="stores"
          item-text="name"
          solo
          dense
          prepend-inner-icon="mdi-store"
        />
      </v-flex>
      <v-flex class="px-2 mt-2" md2 xs4>
        <v-combobox
          item-text="name"
          solo
          dense
          v-model="options.employee"
          :items="employees"
          prepend-inner-icon="mdi-account"
        />
      </v-flex>
    </v-layout>

    <v-layout row class="ma-2">
      <v-flex md12>
        <v-crud-card
          name="timecard"
          v-model="page"
          v-bind:headers="headers"
          v-bind:data="data"
          v-bind:dialog-width="600"
          v-bind:numPages="num_pages"
          v-bind:remove="remove_timecards"
          v-bind:save="save_timecard"
          v-bind:row="typing_timecard"
          @change-pagination="changePagination"
          :loading_items_table_data="data_loading"
          EmployeesTimeCard
          v-bind:add_button_name="'add_timecard'"
          v-bind:saveDisabled="saveDisabled"
        >
          <v-spacer />
          <template #search>
            <v-slide-x-reverse-transition>
              <v-btn icon @click="searchActivate">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-slide-x-reverse-transition>
            <v-slide-x-reverse-transition>
              <v-text-field
                v-model="search"
                ref="search_field"
                v-if="search_text"
                :autofocus="search_field"
                class="mt-3 pa-0"
                append-icon="mdi-close"
                @click:append="
                  {
                    (search_text = false), (search = ''), searchTimeCard();
                  }
                "
                @change="searchTimeCard()"
                label="Search"
              ></v-text-field>
            </v-slide-x-reverse-transition>
            <v-btn icon @click="downloadTimecardsExcel">
              <v-icon> mdi-download </v-icon>
            </v-btn>
            <v-dialog v-model="proccessDialog" max-width="400px">
              <v-card>
                <v-list-item-action style="width: 338px; padding-left: 40px">
                  <v-progress-linear
                    :color="
                      excel_dowload_proccess ? 'primary' : 'rgba(0,0,0,0.26)'
                    "
                    background-color="white"
                    height="10"
                    style="border: 1px solid rgba(0, 0, 0, 0.26)"
                    v-bind:value="excel_dowload_proccess"
                    striped
                  />
                  <v-list-item-action-text
                    >{{ $t("download") }}
                    {{ excel_dowload_proccess.toFixed() + " %" }}
                  </v-list-item-action-text>
                </v-list-item-action>
              </v-card>
            </v-dialog>
          </template>
          <v-card-text>
            <v-form v-model="is_valid">
              <v-layout row class="mx-1">
                <v-flex md6 class="px-1">
                  <v-combobox
                    v-model="timecard.employee"
                    :label="$t('employee')"
                    v-bind:items="employees.slice(1)"
                    item-text="name"
                    item-value="_id"
                    ref="employee"
                    :rules="[fieldRules.require]"
                  />
                </v-flex>
                <v-flex md6 class="px-1">
                  <v-combobox
                    v-model="timecard.store"
                    :label="$t('store')"
                    v-bind:items="stores.slice(1)"
                    item-text="name"
                    ref="store"
                    :rules="[fieldRules.require]"
                  />
                </v-flex>
              </v-layout>
              <v-layout row class="mx-1">
                <v-flex md6 class="px-1 mt-3">
                  <v-datetime-picker
                    :label="$t('clock_in_date')"
                    v-model="timecard.clock_in_date"
                    v-bind:max="timecard.clock_out_date"
                  />
                </v-flex>
                <v-flex md6 class="px-1 mt-3">
                  <v-datetime-picker
                    :label="$t('clock_out_date')"
                    v-model="timecard.clock_out_date"
                    v-bind:min="timecard.clock_in_date"
                  />
                </v-flex>
              </v-layout>
              <v-layout row class="mx-1 mt-3">
                <v-flex md6 class="px-1">
                  <v-text-field
                    v-mask="mask"
                    :label="$t('clock_in_time')"
                    v-on:keyup="pressed(true)"
                    v-model="timecard.clock_in_time"
                    ref="clock_in_time"
                    :rules="[fieldRules.employeeClock]"
                  />
                </v-flex>
                <v-flex md6 class="px-1">
                  <v-text-field
                    v-mask="mask"
                    v-on:keyup="pressed(false)"
                    :label="$t('clock_out_time')"
                    v-model="timecard.clock_out_time"
                    ref="clock_out_time"
                    :rules="[fieldRules.employeeClock]"
                  />
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
        </v-crud-card>
      </v-flex>
    </v-layout>
  </v-application>
  <error404 v-else></error404>
</template>
<script>
import Services from "../../mixins/services";
import fileSaver from "file-saver";
import xlsx from "xlsx";
var now = new Date();
export default {
  name: "EmployeesTimecards",
  mixins: [Services],
  data: () => ({
    options: {
      start_date: new Date(new Date().setDate(now.getDate() - 7))
        .toISOString()
        .substr(0, 10),
      end_date: new Date(new Date().setDate(now.getDate() + 1))
        .toISOString()
        .substr(0, 10),
      custom: false,
      employee: null,
    },
    store: null,
    params: null,
    times: [],
    employees: [{ name: "All employees", _id: "" }],
    headers: [
      { text: "Clock in", value: "clock_in_date" },
      { text: "Clock out", value: "clock_out_date" },
      { text: "Employee", value: "employee_name" },
      { text: "Store", value: "service_name" },
      { text: "Total hours", value: "total_hours" },
    ],
    data: [],
    page: 1,
    num_pages: 0,
    mask: "##:##",
    timecard: {
      timecard_edit_index: -1,
      clock_in_date: new Date().toISOString().substr(0, 10),
      clock_out_date: new Date().toISOString().substr(0, 10),
      clock_in_time: "",
      employee: null,
      store: null,
      clock_out_time: "",
    },
    data_loading: false,
    is_valid: false,
    proccessDialog: false,
    excel_dowload_proccess: 0,
    max_total: 0,
    search: "",
    search_field: false,
    search_text: false,
  }),
  mounted() {
    this.headers = [
      { text: this.$t("employee"), value: "employee_name", available: true },
      { text: this.$t("clock_in"), value: "clock_in_date", available: true },
      { text: this.$t("clock_out"), value: "clock_out_date", available: true },
      { text: this.$t("store"), value: "service_name", available: true },
      { text: this.$t("total_minutes"), value: "minutes", available: true },
      { text: this.$t("total_work_time"), value: "total_work_time", available: true },
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
  },
  computed: {
    form() {
      const formObj = {
        employee: this.timecard.employee,
        store: this.timecard.store,
        clock_in_time: this.timecard.clock_in_time,
        clock_out_time: this.timecard.clock_out_time,
      };
      return formObj;
    },
    saveDisabled() {
      let formHasErrors = false || !this.is_valid;
      Object.keys(this.form).forEach((f) => {
        if (!this.form[f]) formHasErrors = true;
      });
      return formHasErrors;
    },
  },
  methods: {
    async downloadTimecardsExcel() {
      this.proccessDialog = true;
      this.excel_dowload_proccess = 0;
      const start_date = new Date(this.params.start_date);
      const end_date = new Date(this.params.end_date);
      this.loading = true;
      const limit = 500;
      let all_data = [];
      const page_count = Math.ceil(this.max_total / limit);
      for (let page = 1; page <= page_count; page++) {
        const response = this.$communicator.then(
          this,
          await this.$communicator("employee_timecards", {
            arguments: [
              start_date.getTime(),
              end_date.getTime() + (86400000 - 1),
              limit,
              page,
            ],
            params: {
              services: this.params.service != "" ? [this.params.service] : [],
              employees:
                this.params.employee?._id != ""
                  ? [this.params.employee?._id]
                  : [],
            },
          })
        );
        this.excel_dowload_proccess = (page / page_count) * 100;
        all_data.push(...response?.data);
      }
      this.proccessDialog = false;
      this.loading = true;
      const result = all_data.map((timecard) => {
        timecard.total_hours = Number(timecard.total_hours.toFixed())
        const hours = parseInt(timecard.total_hours / 60)
        const minutes = timecard.total_hours - parseInt(timecard.total_hours / 60) * 60
        return {
          Employee: timecard.employee_name,
          Tin: timecard.employee_tin,
          Clock_in_time: this.date_ddmmyy_hhmm(timecard.clock_in),
          Clock_out_time: this.date_ddmmyy_hhmm(timecard.clock_out),
          Store: timecard.service_name,
          "Worked minutes": timecard.total_hours,
          "Worked hours": `${hours}: ${minutes}`,
        }
      });
      const ws = xlsx.utils.json_to_sheet(result);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(wb, { bookType: "xlsx", type: "array" });
      const excel_data = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
      fileSaver.saveAs(excel_data, "TimeCards.xlsx");
    },
    changePagination(page) {
      this.page = page;
      this.update_reports();
    },
    pressed(first) {
      if (first) {
        if (this.timecard.clock_in_time.split) {
          let split = this.timecard.clock_in_time.split(":");
          if (split[0] > 23) {
            split[0] = 23;
          }
          if (split[1] && split[1] > 60) {
            split[1] = 59;
          }
          if (split[1]) {
            this.timecard.clock_in_time = split[0] + ":" + split[1];
          } else {
            this.timecard.clock_in_time = split[0];
          }
        }
      } else {
        if (this.timecard.clock_out_time.split) {
          let split = this.timecard.clock_out_time.split(":");
          if (split[0] > 23) {
            split[0] = 23;
          }
          if (split[1] && split[1] > 60) {
            split[1] = 59;
          }
          if (split[1]) {
            this.timecard.clock_out_time = split[0] + ":" + split[1];
          } else {
            this.timecard.clock_out_time = split[0];
          }
        }
      }
    },
    async remove_timecards(items) {
      var indices = [];
      for (const index in items) {
        indices.push(items[index]._id);
      }
      await this.$communicator("delete_timecards", {
        params: {
          indexes: indices,
        },
      });
      this.$toast.success("Success", { timeout: 2000 });
      this.update(this.params);
    },
    async update_reports() {
      const employees = this.$communicator.then(
        this,
        await this.$communicator("all_employees", {
          params: {
            service: this.store._id,
          },
        })
      );
      if (employees) {
        this.employees = [
          { name: this.$t("all_employees"), _id: "" },
          ...this.$copy(employees),
        ];
        var is = true;
        if (this.options.employee !== null) {
          for (const index in this.employees) {
            if (this.options.employee._id == this.employees[index]._id)
              is = false;
          }
        }
        if (is) this.options.employee = this.$copy(this.employees[0]);
        if (this.update) {
          this.update({ service: this.store._id, ...this.options });
        }
      }
    },
    searchActivate() {
      this.search_text = true;
      if (this.search_field && this.$refs["search_field"]) {
        this.$refs["search_field"].focus();
      }
      this.search_field = true;
    },
    searchTimeCard() {
      this.update();
    },
    async update(params) {
      this.data_loading = true;
      this.params = params;
      const start_date = new Date(this.options?.start_date);
      const end_date = new Date(this.options?.end_date);
      const reports = this.$communicator.then(
        this,
        await this.$communicator("employee_timecards", {
          arguments: [
            start_date.getTime(),
            end_date.getTime() + (86400000 - 1),
            10,
            this.page,
          ],
          params: {
            services: this.store._id != "" ? [this.store._id] : [],
            employees:
              this.options.employee?._id != ""
                ? [this.options.employee?._id]
                : [],
            search: this.search,
          },
        })
      );
      if (reports) {
        this.max_total = reports?.total;
        this.num_pages = reports.page;
        this.data_loading = false;
        var hour, minute;
        for (let i = 0; i < reports.data.length; i++) {
          if (reports.data[i].clock_in) {
            var time = new Date(reports.data[i].clock_in);
            reports.data[i].clock_in_date = this.date_ddmmyy_hhmm(
              reports.data[i].clock_in
            );
          }
          hour = new Date(time).getHours();
          reports.data[i].clock_in_type = hour > 12 ? "PM" : "AM";
          hour = hour > 9 ? hour : "0" + hour;
          minute =
            new Date(time).getMinutes() > 9
              ? new Date(time).getMinutes()
              : "0" + new Date(time).getMinutes();
          reports.data[i].clock_in_time = hour + ":" + minute;
          if (reports.data[i].clock_out) {
            time = new Date(reports.data[i].clock_out);
            reports.data[i].clock_out_date = this.date_ddmmyy_hhmm(
              reports.data[i].clock_out
            );
          }
          reports.data[i].clock_out_time =
            (new Date(time).getHours() > 9
              ? new Date(time).getHours()
              : "0" + new Date(time).getHours()) +
            ":" +
            (new Date(time).getMinutes() > 9
              ? new Date(time).getMinutes()
              : "0" + new Date(time).getMinutes());

          reports.data[i].minutes = Number(reports.data[i].total_hours.toFixed())
          const hours = parseInt(reports.data[i].minutes / 60)
          const minutes = reports.data[i].minutes - parseInt(reports.data[i].minutes / 60) * 60
          reports.data[i].total_work_time = `${hours}: ${minutes} minutes`
        }
        this.data = reports.data;
      }
    },
    typing_timecard(itemm) {
      if (itemm) {
        let item = JSON.parse(JSON.stringify(itemm));
        if (item.clock_in) {
          item.clock_in += 5 * 60 * 60 * 1000;
          item.clock_in_date = new Date(item.clock_in)
            .toISOString()
            .substr(0, 10);
          item.clock_in_time = new Date(item.clock_in)
            .toISOString()
            .slice(11, 16);
        } else {
          item.clock_in_date = "";
          item.clock_in_time = "";
        }
        if (item.clock_out) {
          item.clock_out += 5 * 60 * 60 * 1000;
          item.clock_out_date = new Date(item.clock_out)
            .toISOString()
            .substr(0, 10);
          item.clock_out_time = new Date(item.clock_out)
            .toISOString()
            .slice(11, 16);
        } else {
          item.clock_out_date = "";
          item.clock_out_time = "";
        }

        item.store = { _id: item.service, name: item.service_name };
        item.employee = { _id: item.employee_id, name: item.employee_name };
        this.timecard = item;
      } else {
        this.timecard = {
          timecard_edit_index: -1,
          clock_in_date: new Date().toISOString().substr(0, 10),
          clock_out_date: new Date().toISOString().substr(0, 10),
          clock_in_time: "08:00",
          employee: null,
          store: null,
          clock_out_time: "18:00",
        };
      }
    },
    async save_timecard() {
      let clock_in_time = this.timecard.clock_in_time.split(":");
      this.timecard.clock_in =
        new Date(this.timecard.clock_in_date).getTime() +
        clock_in_time[0] * 60 * 60 * 1000 +
        clock_in_time[1] * 60 * 1000 -
        5 * 60 * 60 * 1000;
      delete this.timecard.clock_in_date;
      delete this.timecard.clock_in_time;
      let clock_out_time = this.timecard.clock_out_time.split(":");
      this.timecard.clock_out =
        new Date(this.timecard.clock_out_date).getTime() +
        clock_out_time[0] * 60 * 60 * 1000 +
        clock_out_time[1] * 60 * 1000 -
        5 * 60 * 60 * 1000;
      delete this.timecard.clock_out_date;
      delete this.timecard.clock_out_time;
      this.timecard.total_hours =
        (this.timecard.clock_out - this.timecard.clock_in) / (60 * 60 * 1000);

      if (this.timecard.employee && this.timecard.store) {
        this.timecard.employee_id = this.timecard.employee._id;
        this.timecard.employee_name = this.timecard.employee.name;
        delete this.timecard.employee;
        this.timecard.service = this.timecard.store._id;
        this.timecard.service_name = this.timecard.store.name;
        delete this.timecard.store;

        if (this.timecard.timecard_edit_index == -1) {
          delete this.timecard.timecard_edit_index;
          await this.$communicator("create_timecard", {
            params: this.timecard,
          });
          this.$toast.success("Success", { timeout: 2000 });
        } else {
          await this.$communicator("update_timecard", {
            arguments: [this.timecard._id],
            params: this.timecard,
          });
          this.$toast.success("Success", { timeout: 2000 });
        }
      }
      this.update_reports();
    },
  },
  watch: {
    "options.start_date": {
      handler() {
        this.update_reports();
      },
    },
    "options.end_date": {
      handler() {
        this.update_reports();
      },
    },
    "options.custom": {
      handler() {
        this.update_reports();
      },
    },
    "options.employee._id": {
      handler() {
        this.update_reports();
      },
    },
    "store._id": {
      handler() {
        this.$store.commit("setItemsService", this.store);
        this.update_reports();
      },
    },
  },
  beforeMount() {
    this.store = this.$store.state.items_current_service;
    this.access = this.$store.state.access;
  },
};
</script>
